import React from "react";
import useProbateBondForm from "../../../features/bonds/probate/hooks/useProbateBondForm";
import BondWizardPageShell from "./BondWizardPageShell";
import { bondWizardPageConfig } from "./bondWizardPageConfig";

const VermostProbateBondRequestForm = () => {
  const form = useProbateBondForm();
  return (
    <BondWizardPageShell config={bondWizardPageConfig.probate} form={form} />
  );
};

export default VermostProbateBondRequestForm;
